module.exports = __webpack_public_path__ + "static/media/resi05.9ed9b4f6.jpeg";